import React, { useState } from 'react';
import './App.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import Booking from './Booking';
import RemoveBooking from './BookingRemove';
import Login from './portal/main/Login';
import AdminLogout from './AdminLogout';
import Index from './portal/main/Index';
import VersionControl from './VersionControl';
import moment from 'moment';
import { Image } from 'react-bootstrap';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import AdminStateContext, { states } from './portal/contexts/AdminStateContext';
// eslint-disable-next-line
import 'moment/locale/sv';

// Google Analytics
// eslint-disable-next-line
const trackingId = "UA-138588684-1";
//ReactGA.initialize(trackingId);

// Configure locales
moment.locale('sv');

// Initialize google analytics page view tracking
//const history = createBrowserHistory();
//history.listen(location => {
// ReactGA.set({ page: location.pathname }); // Update the user's current page
//  ReactGA.pageview(location.pathname); // Record a pageview for the given page
//});

function App() {

  const [state, setState] = useState(states.BUTTON_SELECT);

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <AdminStateContext.Provider value={[state, setState]}>
        <React.Fragment>
          <a href="https://agitura.se" target="_new">
            <Image src="/agitura.png" className="agituraLogo" />
          </a>
          <Router>
            <Switch>
              <Route
                path="/:licenseName/remove/:code"
                children={<RemoveBooking />}
              />
              <Route
                path="/:licenseName/booking"
                children={<VersionControl children={<Booking />} />}
              />
              <Route
                path="/:licenseName/login"
                children={<Login />}
              />
              <Route
                path="/:licenseName/logout"
                children={<AdminLogout />}
              />
              <Route
                path="/:licenseName/admin"
                children={<Index />}
              />
            </Switch>
          </Router>
        </React.Fragment>
      </AdminStateContext.Provider>
    </MuiPickersUtilsProvider>
  );
}

export default App;
